var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filter-b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Registration-PatientF-=Filter",
    transform: "translate(-537.000000, -213.000000)",
    fill: "#0078BF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-b",
    transform: "translate(537.000000, 213.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3430937,0 L0.657015625,0 C0.0741015625,0 -0.220035156,0.707273438 0.192992187,1.12030078 L5.25,6.17807422 L5.25,11.8125 C5.25,12.0266289 5.35448047,12.2273047 5.52991797,12.3501328 L7.71741797,13.8808359 C8.14898438,14.1829297 8.75,13.8767617 8.75,13.3432031 L8.75,6.17807422 L13.8071445,1.12030078 C14.2193242,0.70809375 13.9272109,0 13.3430937,0 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterB);
export default __webpack_public_path__ + "static/media/filter-b.9eec26903f9ca9b80f35a9cfa268ff22.svg";
export { ForwardRef as ReactComponent };